import GameBanner from "../components/banner"
import Login from "../components/login"
import GameNavigation from "../components/navigator"

export const LoginScreen = () => {
    return (
        <>
            <GameNavigation />
            <GameBanner />
            <Login />
        </>
    )
}